import axios from "axios";
import {header} from "./header"

export const SaveAccountDetails = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/SaveAccountDetails`, obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const getAccountList = async () => {
  const CompanyCode = localStorage.getItem('OrgCode');
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/GetAccountList?OrgCode=${CompanyCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}


export const getTESTAccountList = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/GetAccountsData?Orgcode=${obj.id}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}


export const getAccountDetails = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/GetAccountDetails?ACCode=${Obj.ACCode}&ACId=${Obj.ACId}&OrgCode=${Obj.OrgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const DeActiveAccount = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/DeActivateAccounts?ACCode=${Obj.ACCode}&ACId=${Obj.ACId}&OrgCode=${Obj.OrgCode}`,'',{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetGLAccountsListData = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/GetGLAccountsList`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const OpeningBalanceDetails = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/OpeningBalance/AddOpeningBalanceDetails`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetOpeningBalanceDetails = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/OpeningBalance/GetOpeningBalancebyAcCodeName?OrgCode=${Obj.OrgCode}&AccountCode=${Obj.AccountCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const getjournalData = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetJournalTransactionList?OrgCode=${Obj.orgCode}&subOrgCode=${Obj.subOrgCode}&TransactionType=${Obj.TransactionType}&Fromdate=${Obj.Fromdate}&Todate=${Obj.Todate}&Start=0&End=${Obj.End}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetAccountTransationsList = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetAccountTransationsList?OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&Fromdate=${Obj.Fromdate}&Todate=${Obj.Todate}&TransactionType=${Obj.TransactionType}`,{headers:header()})
    return response
  }
  catch (error) {
    return error.response
  }
}

export const SaveOrgBankData = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/SaveOrgBankData`, obj,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}

export const getOrgBankList = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/GetOrgBankDataList?OrgCode=${obj.orgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}

export const getOrgBankById = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/GetOrgBankById?orgCode=${Obj.orgCode}&id=${Obj.id}&CountryCode=${localStorage.getItem('CountryCode')}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}
export const chartofAccountList = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetChartOfAccountList?OrgCode=${obj.orgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}
export const getLedgerList = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetLedgerList?OrgCode=${obj.orgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}
export const getLedgerIdbase = async (Id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetLedgerDetailsById?Id=${Id}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}
export const getTdsTcsList = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetTdsTcsMasterData`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}
export const Saveledger = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/SaveLedgerDetails`, obj,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}
export const GetAccountsList = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetAccountsList?orgcode=${Obj.orgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetReportTypeList = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetReportTypeList?Id=${id}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const AddOrUpdateChartOfAccountDetails = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/AddOrUpdateChartOfAccountDetails`, obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const ChartOfAccountDetailsById = async (Id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/EditChartOfAccountDetails?Id=${Id}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}

export const GetLatestLedgerId = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetLatestLedgerId`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const GetChartOfAccountByPartyId = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetChartOfAccountByPartyId?ParentId=${Obj.ParentId}&orgCode=${Obj.orgCode}&partyEnum=${Obj.partyEnum}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const GetTermsAndConditionsListByTransactionId = async (trnTypeId) =>{
  try{
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/SeriesGeneration/GetTermsAndConditionsListByTransactionId?TrnTypeId=${trnTypeId}&OrgCode=${localStorage.getItem('OrgCode')}`,{headers:header()});
    return response;
  }catch(error){
    return error.response
  }

}

export const getLedgerEffectList = async(Obj)=>{
  try{
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetLedgerEffectList?OrgCode=${Obj.OrgCode}`,{headers:header()});
    return response;
  }
  catch(error){
    return error.response
  }
}

export const saveUpdateLedgerEffect = async(Obj)=>{
  try{
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/saveTransactionLedgerEffect`, Obj,{headers:header()});
    return response;
  }
  catch(error){
    return error.response
  }
}

export const CreateCOAMasterDataForOrganisation = async (obj) => {
  let countryCode = localStorage.getItem('CountryCode'); 
  try {
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/IsMasterDataForAccounting?OrgCode=${obj.OrgCode}&countrySpecific=${countryCode}`,"",{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetCOAStatusToDeactivation = async (Obj) => {
  try{
    const response =  await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetCOAStatusToDeactivation?orgCode=${Obj.orgCode}&deactivationdate=${Obj.deactivationdate}&COAId=${Obj.id}&deactivate=${Obj.deactivate}`,{headers:header()});
    return response;      
  }catch (error){
    return error.response;
  }
}

export const getTransAlocByLedgId = async(Obj)=> {
  let subOrg = localStorage.getItem('LocCode'); 
  try{
    const response =  await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/LedgerTransaction/GetTransAllocDetailsByLedger?ledgerId=${Obj.ledgerId}&type=${Obj.transType}&transId=${Obj.transId}&OrgCode=${Obj.orgCode}&SubOrgCode=${subOrg}&isParty=${Obj.isParty}`,{headers:header()});
    return response;      
  }catch (error){
    return error.response;
  }
}

export const getLedgDetailsByTransId = async(Obj)=> {
  try{
    const response =  await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/LedgerTransaction/GetLedgerDetailsByTransactionId?OrgCode=${Obj.orgCode}&SubOrgCode=${Obj.subOrgCode}&TransactionId=${Obj.transactionId}`,{headers:header()});
    return response;      
  }catch (error){
    return error.response;
  }
}

export const ledgTranSaveAPI = async(Obj)=>{
  // Obj.PartyName = Obj.PartyName ? Obj.PartyName : null;
  // Obj.partyLedgerId = Obj.partyLedgerId? Obj.partyLedgerId:0;
  // Obj.partyCode = Obj.partyCode? Obj.partyCode:null;
  // Obj.locationCode = Obj.locationCode? Obj.locationCode:null;
  try{
    const response =  await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/LedgerTransaction/SaveLedgerDetailsForTransactions`, Obj,{headers:header()});
    return response;      
  }catch (error){
    return error.response;
  }
}

export const UpdatePartyIdForLedger = async(Lid,Pid) => {
  try {
    const response =  await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/UpdatePartyIdForLedger?partyid=${Pid}&ledgerid=${Lid}`,"",{headers:header()});       
    return response;
  } catch (error) {
    return error.response;
  }
}
export const getReportList= async(obj)=> {
  var locobj = JSON.parse(localStorage.getItem('LocDATA'));
 var filterdata =  locobj.obj.DataObj.addresses.filter((x) => (x.addressType === 1 || x.addressType === 3))
 if (filterdata.length > 0) {
 var subcode =  filterdata[0].code;
 }
  try{
    const response =  await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsReports/GetGLReport?FromDate=${obj.fromDate}&ToDate=${obj.toDate}&OrgCode=${obj.orgCode}&subOrgCode=${subcode}&LedgerId=${obj.selectedLedgerId}&MinAmt=${obj.minAmount}&MaxAmt=${obj.maxAmount}&isforwardbalance=true`,{headers:header()});
    return response;   
  }catch (error){
    return error.response;
  }
}   
export const getcreditors = async(Obj)=> {
  try{
    const response =  await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsReports/SundrycredtorsOutstandingReports?OrgCode=${Obj.OrgCode}&TillDate=${Obj.TillDate}`,{headers:header()});
    return response;      
  }catch (error){
    return error.response;
  }
}
export const getDebitors = async(Obj)=> {
  try{
    const response =  await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsReports/SundryDebtorsOutstandingReports?OrgCode=${Obj.OrgCode}&TillDate=${Obj.TillDate}`,{headers:header()});
    return response;      
  }catch (error){
    return error.response;
  }
}
export const GetProfitAndLossAllQuarters = async(obj)=> {
  try{
    const response =  await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsReports/GetProfitAndLossAllQuarters?OrgCode=${obj.OrgCode}&FromDate=${obj.fromDate} &ToDate=${obj.toDate}&openingStock=${obj.openingStock}&openingStockInTransit=${obj.openingStockInTransit}&closingStock=${obj.closingStock}&closingStockInTransit=${obj.closingStockInTransit} &purchaseBillsToMake=${obj.purchaseBillsToMake}&salesBillsToMake=${obj.salesBillsToMake}&provisionalExpenses=${obj.provisionalExpenses}`,{headers:header()});
    return response;      
  }catch (error){
    return error.response;
  }
}

export const GetOpeningStockValues = async(obj)=> {
  try{
    const response =  await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsReports/GetOpeningStockValues?OrgCode=${obj.OrgCode}&FromDate=${obj.fromDate} &ToDate=${obj.toDate}`,{headers:header()});
    return response;      
  }catch (error){
    return error.response;
  }
}

export const GetLedgerPostingTransactionList =async(obj)=>{
  try{
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/LedgerTransaction/GetLedgerPostingTransactionList?OrgCode=${obj.orgCode}&TransactionType=${obj.transactionType}`,{headers:header()});
    return response;
  } catch(error){
    return error.response;
  }
}
export const GenerateForJournaforDoc =async(obj)=>{
  try{
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/SeriesGeneration/GenerateDocNumberForJournal?transtype=${obj.type}&orgcode=${obj.orgCode}&orgbranchcode=${obj.subOrgCode}&transdate=${obj.TransDate}`,{headers:header()});
    return response;
  } catch(error){
    return error.response;
  }
}

export const DeActivateAccounts =async(obj)=>{
  try{
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/DeActivateAccounts?&OrgCode=${obj.OrgCode}&ACId=${obj.ACId}&Deactivate=${obj.Deactivate}&CountryCode=${obj.CountryCode}`,{headers:header()});
    return response;
  } catch(error){
    return error.response;
  }
}
export const SaveBankAccount = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/SaveBankAccount`, obj,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response;
  }
}